import { render, staticRenderFns } from "./ShareLinkModal.vue?vue&type=template&id=ba821484&scoped=true&"
import script from "./ShareLinkModal.vue?vue&type=script&lang=ts&"
export * from "./ShareLinkModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba821484",
  null
  
)

export default component.exports